<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


$(document).ready(function () {
    var targetDiv = $('#guide-steps');
    var footerDiv = $('.fixed-scroll-end-sec');
    var triggerHeight = $(window).height() * 0.1;

    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var targetOffset = targetDiv.offset().top;
        var scrollBottom = $(document).height() - $(window).height() - scrollTop;
        var footerHeight = footerDiv.height();
        
        // Check if scroll is near the #guide-step-one section
        var isNearTarget = scrollTop > (targetOffset - triggerHeight) &&
                           scrollTop < (targetOffset + targetDiv.outerHeight() - triggerHeight);

        // Apply or remove .sec-fixed only if within the section and above the footer
        if (isNearTarget && scrollBottom > (footerHeight + ($(window).height() * 0.3))) {
            targetDiv.addClass('sec-fixed'); // Add class
        } else {
            targetDiv.removeClass('sec-fixed'); // Remove class
        }
    });
});

// $(document).ready(function () {
//   const slider = document.querySelector('.custom-draggable-wrap');

//   let isDown = false;
//   let startX;
//   let scrollLeft;

//   slider.addEventListener('mousedown', (e) => {
//     isDown = true;
//     slider.classList.add('active');
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   });

//   slider.addEventListener('mouseleave', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });

//   slider.addEventListener('mouseup', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });

//   slider.addEventListener('mousemove', (e) => {
//     if (!isDown) return;
//     e.preventDefault();
//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 2; // Adjust the scrolling speed
//     slider.scrollLeft = scrollLeft - walk;
//   });
// });
